import './toast-base.scss';
import React from 'react';
import { ClbToastBase } from '@celebration/design-system/dist/lib/toast-base';
import { createComponent } from '@lit-labs/react';

export default createComponent({
    react: React,
    tagName: ClbToastBase.tagName,
    elementClass: ClbToastBase,
    events: ClbToastBase.events,
});
